import { createContext, useContext } from 'react';
import { LayoutContextProps } from './layout.interface';

export const LayoutContext: any = createContext<LayoutContextProps | null>(
  null,
);
export const useLayoutContext: any = () => useContext(LayoutContext);
